import React, { FC } from 'react'

import { IconBlogProps } from './IconBlog.types'
import * as Styled from './styles/IconBlog.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBlog: FC<IconBlogProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBlogProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconBlogProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M154.67 5.54a18.23 18.23 0 0 0-25.75-.23L110.19 24H24A16 16 0 0 0 8 40v104a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16V49.74L154.69 31a18.31 18.31 0 0 0-.02-25.46zM128 144a8 8 0 0 1-8 8H24a8 8 0 0 1-8-8V40a8 8 0 0 1 8-8h78.17L39 95a4 4 0 0 0-1 1.89l-6.56 26.87a4 4 0 0 0 4.86 4.83l26.82-6.71a4 4 0 0 0 1.86-1.05L128 57.74zm21-118.59-88.93 89-19.32 4.83 4.72-19.34L134.53 11A10.21 10.21 0 0 1 149 25.41z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBlog
